import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

const CrumbBox = props => {
  if (props.data.length === 0) {
    return null
  }

  return (
    <div id="crumb"><div id="crumb-wrap">
      <span><Link to={props.rootKey}>{props.rootVal}</Link></span>
      {
        props.data.map(item => {
          return (
            <em key={item.key}>
              <strong>&gt;</strong>
              {
                item.url ?
                <Link to={item.url}>{item.key}</Link> :
                <span>{item.key}</span>
              }
            </em>
          )
        })
      }
    </div></div>
  )
}

export default CrumbBox
